export const DEFAULT_COL_WIDTH:number = 96;
export const DEFAULT_ROW_HEIGHT:number = 32;
export const DEFAULT_NUM_COLS:number = 52;
export const DEFAULT_NUM_ROWS:number = 100;
